import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { CommonAction, extCommonAction, recipesCommonAction, styledTypography } from '@pkg/primitives';

import BackgroundImage from '../assets/images/background.webp';

export const Wrapper = styled(motion.div)`
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;

    display: flex;
    width: 100%;
    pointer-events: none;
`;

interface TopNavProps {
    $bgImage?: string;
    $hideBackground?: boolean;
    $hideSearch?: boolean;
    $fullWidth?: boolean;
}

export const Background = styled.div<TopNavProps>`
    padding: 35px 40px 20px 40px;
    width: 100%;

    max-width: 1920px;
    margin: 0 auto;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    pointer-events: ${({ $hideSearch }) => ($hideSearch ? 'none' : 'auto')};

    background-repeat: no-repeat;
    background-size: 100vw 100vh;
    background-position: 0 0;
    background-attachment: fixed;
    background-color: #090719;

    ${({ $bgImage }) =>
        $bgImage
            ? css`
                  background-image: url(${$bgImage});
              `
            : css`
                  background-image: url(${BackgroundImage});
              `};

    ${({ $hideBackground }) =>
        $hideBackground &&
        css`
            background-image: none;
            background-color: transparent;
        `};

    ${({ $fullWidth }) =>
        $fullWidth &&
        css`
            max-width: 100%;
        `};
`;

export const LeftSide = styled.div`
    pointer-events: all;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    flex: 1 1 auto;
    min-width: 200px;
`;

export const RightSide = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex: 0 0 auto;
`;

export const SearchWrapper = styled.div`
    width: 100%;
    max-width: 437px;
    min-width: 166px;
`;

interface LinkButtonProps {
    $primary?: boolean;
}

export const LinkButton = styled(CommonAction)<LinkButtonProps>`
    ${({ $primary }) => {
        if ($primary) {
            return css`
                ${recipesCommonAction.primary};
                ${extCommonAction.afterGlowPrimary};
            `;
        } else {
            return css`
                ${recipesCommonAction.blur};
            `;
        }
    }};

    gap: 8px;
    padding: 0 20px;
    height: 40px;
`;

export const LinkButtonIcon = styled.div``;

export const LinkButtonLabel = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
`;
